import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=3bb038ec&scoped=true&"
import script from "./BannerForm.vue?vue&type=script&lang=ts&"
export * from "./BannerForm.vue?vue&type=script&lang=ts&"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=3bb038ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb038ec",
  null
  
)

export default component.exports